import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Cookie, X } from "@phosphor-icons/react";

const KEY = "doudou_cookie_consent_v1";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setVisible(true);
  }, []);

  const set = (choice) => {
    localStorage.setItem(KEY, JSON.stringify({ choice, at: new Date().toISOString() }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:max-w-md z-50" data-testid="cookie-banner">
      <div className="bg-white rounded-3xl border border-rose-100 shadow-2xl shadow-rose-300/30 p-5">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-2xl bg-orange-100 text-orange-600 grid place-items-center shrink-0">
            <Cookie size={22} weight="duotone" />
          </div>
          <div className="flex-1">
            <p className="font-display font-bold text-stone-800">Un cookie, une étiquette, c'est tout 🐰</p>
            <p className="text-sm text-stone-600 mt-1 leading-relaxed">
              Nous utilisons uniquement les cookies <strong>strictement nécessaires</strong> pour vous connecter
              (session, token). Aucun traceur publicitaire. En savoir plus dans notre{" "}
              <Link to="/confidentialite" className="text-orange-600 font-bold">politique de confidentialité</Link>.
            </p>
            <div className="mt-4 flex flex-wrap gap-2">
              <Button onClick={() => set("accepted")} className="bg-orange-500 hover:bg-orange-600 text-white rounded-full font-bold flex-1" data-testid="cookie-accept-button">
                J'ai compris
              </Button>
              <Button onClick={() => set("dismissed")} variant="ghost" className="rounded-full text-stone-500" data-testid="cookie-dismiss-button">
                <X size={18} />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
